import React from 'react';
import { Typography } from '@material-ui/core';
import SwapHorizIcon from '@material-ui/icons/SwapHoriz';
import HourglassEmptyIcon from '@material-ui/icons/HourglassEmpty';
import CancelOutlinedIcon from '@material-ui/icons/CancelOutlined';
import { useStyles } from './styles';

const ConnectorLabel = ({ icon: Icon, label, pillClass }) => {
  const classes = useStyles();
  return (
    <div className={`${classes.connectorPill} ${pillClass}`}>
      {Icon && <Icon className={classes.pillIcon} />}
      <Typography component="span" className={classes.pillText}>
        {label}
      </Typography>
    </div>
  );
};

const ContainerStatusExchange = ({ situationStatus, statusType }) => {
  const classes = useStyles();

  return (
    <div className={classes.status}>
      {situationStatus === statusType.RECUSADO && (
        <ConnectorLabel
          icon={CancelOutlinedIcon}
          label="Cancelada"
          pillClass={classes.pillCancel}
        />
      )}
      {(situationStatus === statusType.CONFIRMADO ||
        situationStatus === statusType.OCORRENDO ||
        situationStatus === statusType.REALIZADO) && (
        <ConnectorLabel
          icon={SwapHorizIcon}
          label="Trocou com"
          pillClass={classes.pillConfirm}
        />
      )}
      {situationStatus === statusType.SOLICITADO && (
        <ConnectorLabel
          icon={HourglassEmptyIcon}
          label="Não confirmada"
          pillClass={classes.pillWaiting}
        />
      )}
    </div>
  );
};

export default ContainerStatusExchange;
